import { type ReactNode } from 'react';

import { Content, EmbeddedContent, Overlay } from './styles';

export interface IFormLayoutProps {
  children: ReactNode;
  dataCy?: string;
  variant?: 'modal' | 'embedded';
}

export const FormLayout = ({
  children,
  dataCy = 'form-container',
  variant = 'modal',
}: IFormLayoutProps): JSX.Element => {
  if (variant === 'embedded') {
    return <EmbeddedContent data-cy={dataCy}>{children}</EmbeddedContent>;
  }

  return (
    <>
      <Overlay data-cy="overlay" />
      <Content data-cy={dataCy}>{children}</Content>
    </>
  );
};
